import React, { FC, InputHTMLAttributes } from "react";
import { Box, Input, InputProps } from "theme-ui";

interface ButtonSubmitProps extends InputHTMLAttributes<HTMLInputElement> {
  value: string;
  disabled: boolean;
}

export const ButtonSubmit: FC<ButtonSubmitProps> = ({
  value,
  disabled,
  ...props
}: InputProps) => (
  <Box sx={{ gridColumn: "1 / -1" }}>
    <Input
      variant="buttons.primary"
      type="submit"
      {...props}
      value={value}
      disabled={disabled}
      sx={{
        width: "auto",
        textAlign: "center",
        padding: ".75rem 1.5rem",
        cursor: "pointer",
        borderWidth: "0px",
      }}
    />
  </Box>
);
